import React, { useEffect, useRef } from 'react'
import { useTranslation } from 'react-i18next'
import styles from './SimpleDetails.module.css'
import classNames from 'classnames'
import { useResize } from 'hooks/useResize'
import { CustomFieldsDetailsColumn } from 'components/CustomFields/CustomFieldsColumn'

export function DetailsColumn ({
  visible = true,
  ...rest
}) {
  if (!visible) return null

  return (
    <Column {...rest}/>
  )
}

function Column ({
  section,
  onWidthChange,
  children,
  index,
  isLastElementInRow,
  showCustomFields = true
}) {
  const { t } = useTranslation()
  const componentRef = useRef()
  const { width } = useResize(componentRef)

  useEffect(() => onWidthChange(width, index), [width, index, onWidthChange])

  return (
    <div className={classNames(styles.detailsColumn, isLastElementInRow ? 'flex-grow-1' : '')}>
      {section.label && <div className={styles.header}>{t(section.label)}</div>}
      <div ref={componentRef} className={styles.detailsContentColumn}>
        {children}
        {showCustomFields && <CustomFieldsDetailsColumn section={section}/>}
      </div>
    </div>
  )
}
